export function initReveal() {
    // When element [data-fly-reveal] is in view, make it fly in by translating it from the right
    const flyReveal = document.querySelectorAll('[data-fly-reveal]');

    flyReveal.forEach((flyReveal, index) => {
        if (index % 2 === 0) {
            flyReveal.classList.add('-translate-x-full');
        } else {
            flyReveal.classList.add('translate-x-full');
        }
    });

    // Remove translate class when element is in view by atleast 50% of height
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.remove('translate-x-full');
                    entry.target.classList.remove('-translate-x-full');
                }
            });
        },
        {
            threshold: 0.5,
        },
    );

    flyReveal.forEach((flyReveal) => {
        observer.observe(flyReveal);
    });
}
